module.exports = __webpack_public_path__ + "static/empty-e457f46011f6fb781df0597fbfeb117d.png";